import React from 'react'
import { Firebase } from '../../../../Core'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { FormattedMessage } from 'react-intl'

import PropTypes from 'prop-types'

import * as selectors from '../endgame.selectors'

import UserShield from '../../../Components/UserShield'
import * as utils from '../../../Ranking/ranking.utils'

const NO_USER = { colonyName: 'NO PLAYER', coins: 0, settlers: 0, cityLevel: 1 }

class Podium extends React.Component {
  renderUser(userPodium, position) {
    const { report, currentUser, rankingObfuscated } = this.props
    const user = userPodium ? userPodium : NO_USER
    const userAnswers = report.podiumCorrectAnswers[user.licenseId]
    const answersAvg =
      userPodium && userAnswers.answered
        ? (userAnswers.rightAnswered * 100) / userAnswers.answered
        : 0
    let obfuscated = rankingObfuscated == 'undefined' ? 'normal' : rankingObfuscated
    let name =
      obfuscated == 'obfuscated'
        ? utils.obfuscated(user.name, currentUser)
        : obfuscated == 'alias'
        ? user.name == currentUser.name
          ? user.name
          : user.alias
        : user.name
    return (
      <div key={position} className="endgame--position">
        <UserShield shield={user.colonyShield} />
        <ul className="endgame--info">
          <li>
            <span className="num--position">{position}º</span>
          </li>
          <li>
            <div className="text">
              <FormattedMessage id={'map.buildings.city_level.' + user.cityLevel} />
            </div>
            <div className="text">{user.colonyName}</div>
            <div className="text">{name}</div>
          </li>
        </ul>
        <ul className="endgame--info__results">
          <li>
            <span className="icon-colonos"></span>
            <span>{user.settlers}</span>
          </li>
          <li>
            <span className="icon-coin violet"></span>
            <span className="violet">{user.coins}</span>
          </li>
          <li>
            <span className="icon-doing darkgreen"></span>
            <span className="darkgreen">{answersAvg.toFixed(1)}%</span>
          </li>
        </ul>
      </div>
    )
  }

  render() {
    const { report } = this.props

    if (!report.podium) {
      return null
    }

    return (
      <div className="endgame--layer">
        {report.podium.map((user, index) => this.renderUser(user, index + 1))}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    report: selectors.report(state),
    currentUser: Firebase.selectors.getUserData(state),
    rankingObfuscated: Firebase.selectors.getObfuscatedRankingFlag(state),
  }
}

Podium.propTypes = {
  report: PropTypes.object,
  currentUser: PropTypes.object,
  rankingObfuscated: PropTypes.string,
}

export default connect(mapStateToProps, null)(injectIntl(Podium))
